import { render, staticRenderFns } from "./Quit.vue?vue&type=template&id=52b3e69c&scoped=true"
import script from "./Quit.vue?vue&type=script&lang=js"
export * from "./Quit.vue?vue&type=script&lang=js"
import style0 from "./Quit.vue?vue&type=style&index=0&id=52b3e69c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b3e69c",
  null
  
)

export default component.exports